export default {
  // "SRD_IndieHacker": [
  //     {
  //         StartingRole: "SRD_Professional",
  //         GumroadCode: "KDLxE",
  //         Price: 82
  //     },
  // ],
}
